<template>
  <div class="main-container flex flex-col">
    <div class="header-complete-pickup text-zt-white bg-zt-primary-200 w-full lg:hidden flex items-center px-6">
      <div @click="returnCreate" class="outline-none text-left w-1/3 text-zt-xl" data-vs-button="return">
        <zt-icon name="angle-left" />
      </div>
      <div class="w-1/3 text-center font-bold">
        {{ eformName }}
      </div>
      <div class="text-zt-xl text-right w-1/3"></div>
    </div>
    <div class="items-center hidden lg:flex">
      <div @click="returnCreate" class="cursor-pointer text-zt-lg pt-2 text-zt-primary-200 mr-10"
        data-vs-button="return-create">
        <zt-icon name="angle-left" /> {{ $t("message.menuComponent.back") }}
      </div>
      <HeaderPickup :title="eformName" />
    </div>
    <div class="main-title fixed md:relative order-2 lg:order-none px-4"
      :class="windowsResize.width < 1024 ? 'bottom-0 pb-2' : ''">
      <div class="md:pl-24 bg-white send-container lg:absolute">
        <button class="send-btn w-32 md:w-full lg:w-48 outline-none" dark @click="sendEform()"
          data-vs-button="send-eform">
          {{ $t("message.menuComponent.item4") }}
        </button>
      </div>
    </div>
    <div v-if="loading" class="mt-20">
      <vue-loading v-if="loading" background-color="rgba(0,0,0,0.0)" :active="loading" color="#4F41A3" width="60"
        height="60" :is-full-page="false" />
    </div>
    <zt-modal max-width="450px" :show-button-close="false" class="rounded" :active="showLoader">
      <template slot="modal-header">
        <div class="w-full">
          <p class="p-4 text-zt-lg font-medium text-white">
            {{
              $t('message.documentVisualizerComponent.signDialog.signConfort')
            }}
          </p>
        </div>
      </template>
      <div class="p-4">
        <div class="flex items-center mx-auto">
          <div class="flex-none">
            <div slot="icon" class="sign-loader"></div>
          </div>
          <div class="flex-grow">
            <div class="pl-4">
              {{
                $t('message.documentVisualizerComponent.loading.loadingMessage')
              }}
            </div>
          </div>
        </div>
      </div>

    </zt-modal>
    <iframe class="order-1 mt-2 lg:mt-0" v-show="!loading" @load="loadIframe" id="documentframe"
      style="width: 100%; min-height: calc(100vh - 130px); max-height: calc(100vh - 108px)" frameborder="0"></iframe>
  </div>
</template>

<script>
import Users from '@/apiClient/Users'
import Eforms from '@/apiClient/Eforms'
import PickUp from '@/apiClient/PickUp'
import HeaderPickup from './HeaderPickup'
import { store, mutations } from '../store'
import { useWindowResize } from '@sichern/ui-elements'
import { mapState } from 'vuex'

export default {
  name: 'CompletePickUp',
  components: {
    HeaderPickup
  },
  data() {
    return {
      eformOk: 3,
      eformImageError1: 12029,
      eformImageError2: 12030,
      jwtPickUp: '',
      eformInstance: '',
      userInstance: '',
      pwd: '',
      eformName: '',
      loading: true,
      headerComponentRef: null,
      mainComponentRef: null,
      windowsResize: useWindowResize(this),
      showLoader: false
    }
  },
  watch: {
    'windowsResize.width': function (newValue) {
      if (newValue > 1023) {
        this.headerComponentRef.classList.remove('hidden')
        this.headerComponentRef.classList.add('flex')
        this.mainComponentRef.classList.add('pb-20')
        this.mainComponentRef.classList.add('pt-16')
      } else {
        this.headerComponentRef.classList.remove('flex')
        this.headerComponentRef.classList.add('hidden')
        this.mainComponentRef.classList.remove('pb-20')
        this.mainComponentRef.classList.remove('pt-16')
      }
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created() {
    this.eformInstance = new Eforms()
    this.userInstance = new Users()
    this.pickupInstance = new PickUp()
    this.getToken()
    this.eformName = store.eform.nombre
    this.headerComponentRef = this.$parent.$parent.$refs['header']
    this.mainComponentRef = this.$parent.$parent.$refs['main']
    if (this.windowsResize.width < 1024) {
      this.headerComponentRef.classList.remove('flex')
      this.headerComponentRef.classList.add('hidden')
      this.mainComponentRef.classList.remove('pb-20')
      this.mainComponentRef.classList.remove('pt-16')
    }
  },
  methods: {
    async getToken() {
      const res = await this.eformInstance.token()

      this.jwtPickUp = res.data.results.data[0]

      this.getUrl()
    },
    async getUrl() {
      const fullName = `${this.user.nombre} ${this.user.apellido}`
      const res = await this.eformInstance.client.loadUrl(
        this.jwtPickUp,
        fullName,
        store.hashEform
      )
      const element = document.getElementById('documentframe')

      if (element != null) {
        const doc = element.contentWindow.document
        doc.open()
        doc.write(res.data)
        doc.close()
      }
    },
    sendEform() {
      const element = document.getElementById('documentframe')

      const iframe = element.contentWindow

      iframe.viewer.emit('send').then(result => {
        if (result === this.eformOk) {
          this.$swal({
            title: this.$t('message.Pickup.title_eforms_sign').toString(),
            html: `<input type="password" id="pass-input" class="swal2-input">
            <input type="checkbox" onclick="const inputElement = document.getElementById('pass-input'); inputElement.type === 'password' ?inputElement.type = 'text' : inputElement.type = 'password';"> ${this.$t("message.searchComponent.show_password")}`,
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: this.$t('message.Pickup.text_send').toString(),
            showLoaderOnConfirm: false,
            reverseButtons: true,
            cancelButtonColor: '#88A09E',
            confirmButtonColor: '#54CAA6',
            cancelButtonText: this.$t('message.Pickup.cancel').toString(),
            preConfirm: () => {
              const inputElement = document.getElementById('pass-input')
              const pwd = inputElement.value
              this.pwd = pwd
              return this.eformInstance
                .validPass(pwd)
                .then(response => {
                  if (response.data.results.data[0] == false) {
                    throw new Error(response.data.results.data[0])
                  }
                })
                .catch(() => {
                  this.$swal.showValidationMessage(
                    this.$t('message.Pickup.text_fail_password').toString()
                  )
                })
            }
          }).then(async (res) => {
            if (res.value) {
              this.showLoader = true
              await this.GetIdDocAndSign()
              this.showLoader = false
            }
          })
        }
      }).catch(error => {
        let message;
        if (error === this.eformImageError1) {
          message = this.$t('message.eforms.errors.e12029').toString()
        }
        if (error === this.eformImageError2) {
          message = this.$t('message.eforms.errors.e12030').toString()
        }
        if (message) {
          this.$swal({
            title: this.$t('message.eforms.titles.warning').toString(),
            type: "warning",
            text: message,
            inputAttributes: {
              autocapitalize: 'off'
            },
            confirmButtonText: this.$t('message.Pickup.accept').toString(),
            showLoaderOnConfirm: false,
            reverseButtons: true,
            confirmButtonColor: '#4f41a3'
          })
        }
      })
    },
    async GetIdDocAndSign() {
      const res = await this.pickupInstance.sendEform(
        store.hashEform,
        store.eform.id
      )

      const {
        results: {
          data: { id }
        }
      } = res.data

      if (id) {
        const reason = 'FIRMADO CONFORME'
        const appId = this.user.aplicacion.id

        const documentSigned = await this.eformInstance.signDocument(
          this.pwd,
          appId,
          id,
          reason
        )

        if (documentSigned.data.code !== 200) {
          return this.$swal({
            type: 'error',
            title: this.$t("message.DocumentsComponents.failSaved")
          })
        }

        if (store.eform.requires_approval) {
          await this.eformInstance.updateToPending(appId, id)
        }

        this.$swal({
          type: 'success',
          title: this.$t("message.DocumentsComponents.documentSended")
        }).then(() => {
          this.$router.push({ name: 'pickup' })
        })
      }
    },
    returnCreate() {
      mutations.setEformSelected('')
      mutations.setHashEform('')
      this.$router.back()
    },
    loadIframe() {
      setTimeout(() => (this.loading = false), 1000)
    }
  },
  beforeDestroy() {
    const header = this.$parent.$parent.$refs['header']
    header.classList.add('flex')
    header.classList.remove('hidden')
    const main = this.$parent.$parent.$refs['main']
    main.classList.add('pb-20')
    main.classList.add('pt-16')
  }
}
</script>

<style scoped>
.main-container {
  width: 100%;
  height: 100%;
}

.main-title {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
}

.send-container {
  top: 24px;
}

.send-btn {
  height: 36px;
  background: var(--branding-primary, #4f41a3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.0357143em;
  color: #ffffff;
}

.header-complete-pickup {
  height: 64px;
}

.outline-none {
  outline: none;
}

.sign-loader {
  border: 16px solid #F5F5F5;
  border-top: 16px solid #4F41A3;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
